import createCrud from './crud';


export default createCrud({
    resource: 'settings/sign-requests/templates',
  });